module.exports = __webpack_public_path__ + "img/14.d7d78f9b.jpg";